import { z } from 'zod';

// TechlogAirport schema
export const ZTechlogAirport = z.object({
  id: z.number().describe('Unique identifier for the airport in the system'),
  icaoCode: z
    .string()
    .describe(
      'ICAO (International Civil Aviation Organization) 4-letter code for the airport (e.g., "KJFK" for John F. Kennedy International Airport)',
    ),
  iataCode: z
    .string()
    .describe(
      'IATA (International Air Transport Association) 3-letter code for the airport (e.g., "JFK" for John F. Kennedy International Airport)',
    ),
  latitude: z
    .string()
    .describe('Latitude coordinate of the airport (decimal degrees)'),
  longitude: z
    .string()
    .describe('Longitude coordinate of the airport (decimal degrees)'),
});

// Export inferred TypeScript type
export type TechlogAirport = z.infer<typeof ZTechlogAirport>;
